import { FORM_ID } from "../../../../../constants/Forms";
import ReviewSignSectionHeader from "./ReviewSignSectionHeader";

function ReviewEOC(props) {
  const toggleForm = () => {
    props.toggleForm(FORM_ID.ERRORS_OMISSIONS);
  };
  return (
    <div id="view-eoc">
      <ReviewSignSectionHeader
        toggleForm={toggleForm}
        id={"eoc"}
        headerText="Errors and Omissions Coverage"
      ></ReviewSignSectionHeader>

      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" id="status">
          <h5 id="sts">Status</h5>
        </div>
        <div id="eoc_status" className="col-lg-10 col-md-10 col-sm-12 data">
          {props.errorsOmissionsCoverage.eoindgreatermil === true &&
            "I currently have an individual E&O coverage policy that is equal to or greater than $1 million"}
          {props.errorsOmissionsCoverage.eoindlessmil === true &&
            "I currently have an individual E&O coverage policy that is less than $1 million"}
          {props.errorsOmissionsCoverage.eogroup === true &&
            "I am currently covered under a Group E&O policy"}
        </div>
      </div>
    </div>
  );
}

export default ReviewEOC;
